// src/components/sections/StyledCoreValuesGrid.jsx
import React from 'react';
import coreValuesData from '../../data/coreValuesData';
import ValueIcon from '../ui/ValueIcon';

/**
 * A styled core values grid that matches the design of the Firm page
 * This resembles the dark grid in the wireframe but with lighter styling
 */
const StyledCoreValuesGrid = () => {
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-serif font-bold text-gray-900">Our Core Values</h2>
          <div className="w-24 h-1 bg-secondary mx-auto my-4"></div>
        </div>

        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {coreValuesData.map((value, index) => (
              <div key={index} className="bg-white border border-gray-200 rounded-lg shadow-sm p-6 flex flex-col items-center">
                <div className="bg-gray-100 w-16 h-16 rounded-full flex items-center justify-center mb-4">
                  <ValueIcon icon={value.icon} className="h-8 w-8 text-primary" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">{value.title}</h3>
                <p className="text-gray-600 text-center">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default StyledCoreValuesGrid;